import { LOCALE_STATUS } from '../../constants';
export var getLocales = function (state) { return state.locales; };
export var getLocaleByLanguage = function (state, language) { return getLocales(state).find(function (locale) { return locale.id === language; }); };
export var getDefaultSiteLocale = function (state) {
    return getLocales(state).find(function (locale) { return locale.status === LOCALE_STATUS.DEFAULT; });
};
